import { ProcessedAuthorContent } from "@app/types/Opensearch";
import dummyImage from "@assets/images/author.png";
import mailIcon from "@assets/images/author-email.svg";
import { Image } from "@elements/ResponsiveImage/Image";
import Link from "@elements/Typography/Link";
import { twMerge } from "tailwind-merge";

export type AuthorCardProps = {
  author: ProcessedAuthorContent;
  displayWidth: number;
  displayHeight: number;
  imageWrapper?: string;
  hasEmail?: boolean;
  hrefTitle?: boolean;
  authorCardWrapper?: string;
  nameClass?: string;
  forAuthorListing?: boolean;
};

export default function AuthorCard({
  author,
  displayWidth,
  displayHeight,
  imageWrapper,
  authorCardWrapper,
  nameClass,
  hasEmail = true,
  hrefTitle = false,
  forAuthorListing = true,
}: AuthorCardProps) {
  const { urlPath, email, name, authorImage } = author;
  const { url } = authorImage ?? {};

  const imageUrlWithFallback = url ?? dummyImage;

  return (
    <div className={twMerge("flex gap-4", authorCardWrapper)}>
      <div className={twMerge("w-[110px]", imageWrapper)}>
        <Image
          displayWidth={displayWidth}
          srcWidth={displayWidth}
          srcHeight={displayHeight}
          src={imageUrlWithFallback}
          alt={name}
          dataTestId="author"
          className="rounded-[55px]"
        />
      </div>
      <div className="flex flex-col justify-center">
        {hrefTitle ? (
          <div className="text-md text-black-200 font-semimedium">{name}</div>
        ) : (
          <a
            href={forAuthorListing ? `mailto:${email}` : urlPath}
            className={twMerge(
              "text-xs lg:text-md font-secondary text-blue-300 hover:text-blue-700 hover:underline",
              nameClass,
            )}
          >
            {name}
          </a>
        )}
        {hasEmail && email && (
          <Link
            className="flex text-xs text-grey-400 gap-1 items-center hover:text-blue-700 hover:underline"
            destination={`mailto:${email}`}
            relativePath={false}
          >
            <img src={mailIcon} width={25} height={17} alt={name} />
            <span>{email}</span>
          </Link>
        )}
      </div>
    </div>
  );
}
